module.exports = __webpack_public_path__ + "img/vegas4.52876ac3.webp";